module.exports = __webpack_public_path__ + "img/code1.7f5e0432.png";